import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavBar from "./NavBar";
import Footer from "./Footer";
import CardTiposDePagamentos from "./CardTiposDePagamentos";
import InputPagamento from "../components/Inputs/InputPagamento";
import { CheckCheck, ChevronLeft, LoaderCircle, OctagonAlert } from "lucide-react";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../Contexts/AuthContext";
import MpesaStatusCard from "../components/Cards/MpesaStatusCard";
import { getMpesaFeedback } from "../utils/mpesaResponses";
import { criarReciboPagamento, montarReciboPagamento } from "../utils/recibosPagamento";

const API_URL =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:8002"
    : "https://api-eyazs-production-8f74.up.railway.app");
const TAXA_INSTALACAO = 1500;

export default function PagamentoResidenciaTrimestre() {
  const { id } = useParams();
  const [plano, setPlano] = useState({});
  const [contador, setContador] = useState(1);
  const [numeroMpesa, setNumeroMpesa] = useState(null);
  const [mensagemInput, setMensagemInput] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState(null);
  const [perfil, setPerfil] = useState("");
  const [profile, setProfile] = useState("");
  const [pago, setPago] = useState(false);
  const [preco, setPreco] = useState();
  const [meses, setMeses] = useState(3);
  const [resumoPagamento, setResumoPagamento] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { atualizarPlanoLocal } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const primeiroPagamentoEstimado = searchParams.get("primeiro") === "1";
  const resumoPagamentoValido = resumoPagamento && Number(resumoPagamento.valorPlano || 0) > 0;
  const primeiroPagamento = resumoPagamentoValido
    ? Number(resumoPagamento.taxaInstalacao || 0) > 0
    : primeiroPagamentoEstimado;
  const taxaInstalacao = resumoPagamentoValido
    ? Number(resumoPagamento.taxaInstalacao || 0)
    : primeiroPagamento
      ? TAXA_INSTALACAO
      : 0;
  const validadeComprada = Number(meses || 3) * 31;
  const valorPlanoLocal = Number(preco || plano.preco || 0) * (Number(meses || 3) / 3);
  const valorPlanoPagamento = resumoPagamentoValido
    ? Number(resumoPagamento.valorPlano || 0)
    : valorPlanoLocal;
  const totalPagamento = resumoPagamentoValido
    ? Number(resumoPagamento.valorFinal || 0)
    : valorPlanoPagamento + taxaInstalacao;

  const gerarDataAtual = () => {
    const dataAtual = new Date();
    // Obtém as partes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    // Obtém as partes do horário
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    // Constrói a data no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    return dataFormatada;
  };

  //ola mundo

  useEffect(() => {
    let ativo = true;

    async function carregarResumoPagamento() {
      const token = JSON.parse(localStorage.getItem("token"));
      if (!token || !profile) {
        setResumoPagamento(null);
        return;
      }

      try {
        const dadosUsuario = jwtDecode(token);
        const params = new URLSearchParams({
          profile,
          profileusuario: profile,
          precousuario: String(preco || plano.preco || 0),
          meses: String(meses || 3),
          trimestral: "true",
          primeiroPagamento: primeiroPagamentoEstimado ? "true" : "false",
        });
        const resposta = await axios.get(
          `${API_URL}/pagamento/resumo/${dadosUsuario.idUsuario}?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (ativo && Number(resposta.data?.valorPlano || 0) > 0) {
          setResumoPagamento(resposta.data);
        } else if (ativo) {
          setResumoPagamento(null);
        }
      } catch (erro) {
        if (ativo) {
          setResumoPagamento(null);
        }
      }
    }

    carregarResumoPagamento();

    return () => {
      ativo = false;
    };
  }, [profile, preco, plano.preco, meses, primeiroPagamentoEstimado]);

  async function mostrar() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const dados = await axios.get(
        `${API_URL}/planoresidencialtrimestral/${id}`,
        {
          headers:{
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
          }
        }
      );
      const nomePlano = dados.data.plano || dados.data.profile || dados.data.nome || "";
      if (nomePlano === "PLANO-6Mbps") {
        setPerfil("Plano ferro 3Mbps");
      } else if (nomePlano === "PLANO-8Mbps") {
        setPerfil("Plano Prata 5Mbps");
      } else if (nomePlano === "PLANO-10Mbps") {
        setPerfil("Plano Cobre 8Mbps");
      } else if (nomePlano === "PLANO-12Mbps") {
        setPerfil("Plano Aluminio 10Mbps");
      } else if (nomePlano === "PLANO-14Mbps") {
        setPerfil("Plano Ouro 12Mbps");
      } else if (nomePlano === "PLANO-16Mbps") {
        setPerfil("Plano Chumbo 14Mbps");
      } else if (nomePlano === "PLANO-18Mbps") {
        setPerfil("Plano Mercurio 16Mbps");
      } else if (nomePlano === "PLANO-20Mbps") {
        setPerfil("Plano 18Mbps");
      } else {
        setPerfil(nomePlano);
      }
      setProfile(nomePlano);
      setPreco(dados.data.preco);
      setPlano(dados.data);
    } catch (erro) {
      console.log(erro);
    }
  }

  const gerarLetrasAleatorias = (tamanho) => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let resultado = "";
    for (let i = 0; i < tamanho; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return resultado;
  };

  async function recarregarPacote() {
    setMensagemInput("");
    setPagamentoStatus(null);
    setLoading(true);
    try {
      if (!/^(84|85)\d{7}$/.test(numeroMpesa)) {
        console.log(
          "Número de telefone inválido. Deve começar com 84 ou 85 e conter 9 dígitos."
        );
        setLoading(false);
        setMensagemInput(
          "Por favor, insira um número de telefone válido no maximo 9 numeros começando com 84 ou 85."
        );
        return;
      }
      let valoresAleatorios = gerarLetrasAleatorias(12);
      const token = JSON.parse(localStorage.getItem("token"));
      if(token){
        const dadosDoLocalStorage = jwtDecode(token)
        if(!dadosDoLocalStorage){
          console.log("Token não encontrado no localStorage.");
          return;
        }
        if (!profile || profile === "default") {
          setPagamentoStatus({
            code: "PLANO",
            message: "Nao foi possivel identificar o pacote escolhido. Escolha novamente o plano e tente pagar.",
            type: "error",
          });
          return;
        }
        const dataTransacaoPagamento = gerarDataAtual();
        const reciboPagamento = montarReciboPagamento({
          idUsuario: dadosDoLocalStorage.idUsuario,
          userName: dadosDoLocalStorage.name,
          numeroTelefone: numeroMpesa,
          valor: totalPagamento,
          plano: profile,
          descricao: primeiroPagamento ? `${profile} + Taxa de Instalacao` : profile,
          dataTransacao: dataTransacaoPagamento,
          referenciaPagamento: valoresAleatorios,
        });
          // PAGAMENTO MPESA
          const dadosPagamento = await axios.put(
            `${API_URL}/pagamentotrimestre/${dadosDoLocalStorage.idUsuario}`,
            {
              transaction_ref: "EyazsImperium",
              msisdn: `258${numeroMpesa}`,
              amount: parseFloat(totalPagamento),
              thirdparty_ref: valoresAleatorios,
              meses: Number(meses),
              primeiroPagamento: primeiroPagamentoEstimado,
              criarRecibo: true,
              numeroTelefone: numeroMpesa,
              plano: profile,
              profile: profile,
              profileusuario: profile,
              precousuario: parseFloat(preco),
              descricaoRecibo: reciboPagamento.descricao,
              dataTransacao: dataTransacaoPagamento,
              referenciaPagamento: valoresAleatorios,
            },
            {
              headers:{
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
      if (dadosPagamento) {
        const feedbackPagamento = getMpesaFeedback(dadosPagamento.data);
        if (feedbackPagamento.code !== "INS-0") {
          setPagamentoStatus(feedbackPagamento);
          return;
        }

        //ATUALIZAR PROFILE
        try {
          const atualizarProfile = await axios.put(
            `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
            {
              profile: profile,
            },
            {
              headers:{
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
          if (atualizarProfile) {
            console.log("Plano atualizado com Sucesso!");
            try {
              if (atualizarProfile) {
                console.log("plano atualizado!");
                const atualPrecoUsuario = await axios.put(
                  `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                  {
                    precousuario: parseFloat(preco),
                    profileusuario: profile,
                    validadeusuario:"3 meses"
                  },
                  {
                    headers:{
                      'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                      'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                    }
                  }
                );
                if (atualPrecoUsuario) {
                  const dataAtual = gerarDataAtual();
                  console.log(dadosDoLocalStorage.idUsuario)
                  console.log(dadosDoLocalStorage.name)
                  console.log(numeroMpesa)
                  console.log(preco)
                  console.log(profile)
                  console.log(dataAtual)
                  console.log(
                    "Preco e Plano do usuario Atualizados com Sucesso!"
                  );
                  try {
                    if (!dadosPagamento.data?.reciboCriado && !dadosPagamento.data?.reciboId) {
                      await criarReciboPagamento({
                        apiUrl: API_URL,
                        token,
                        recibo: reciboPagamento,
                      });
                    }
                    console.log("Recibo gerado com Sucesso!");
                    localStorage.setItem("profileAtual", profile);
                    atualizarPlanoLocal(profile);
                    setPagamentoStatus(getMpesaFeedback(dadosPagamento.data));
                    setPago(false);
                  } catch (erro) {
                    console.log(erro);
                    localStorage.setItem("profileAtual", profile);
                    atualizarPlanoLocal(profile);
                    setPagamentoStatus(getMpesaFeedback(dadosPagamento.data));
                    setPago(false);
                  }
                }
                console.log("Plano atualizado com Sucesso!");
              }
            } catch (erro) {
              console.log(erro);
            }
          } else {
            console.log("Erro ao realizar o pagamento");
            setMensagemInput("Clique novamente em Pagar");
          }
        } catch (erro) {
          console.log(erro);
        }
      }
      }
    } catch (erro) {
      console.log("Erro ao recarregar pacote:", erro.message);
      setPagamentoStatus(getMpesaFeedback(erro));
    } finally {
      setNumeroMpesa("");
      setLoading(false);
    }
  }
  const propsCardPlanoResidencial = {
    url: "../../images/vodacom.png",
    descricao: "Pagamento via M-pesa",
  };

  const propsCardPlanoEmpresarial = {
    url: "../../images/movitel.jpeg",
    descricao: "Pagamento via E-mola",
  };

  const propsInputPagamentoMpesa = {
    type: "number",
    placeholder: "digite o numero do Mpesa",
    mudar: (e) => setNumeroMpesa(e.target.value),
    numeroMpesa: numeroMpesa,
  };

  useEffect(() => {
    mostrar();
    console.log(numeroMpesa)
    console.log(preco)
    console.log(profile)

  }, []);

  return (
    <div className="flex h-screen flex-col justify-between">
      {/* NavBar */}
      <div className="bg-blue-500 h-[300px] sticky top-0 z-10">
        <NavBar />
      </div>
      {/* Conteúdo Principal */}
      {pago ? (
        <div className="flex justify-center items-center h-full z-0">
          <div className="bg-green-700 m-8 text-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-md w-full text-center">
            <div className="flex justify-center mb-4">
            <CheckCheck size={50} strokeWidth={2} />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold mb-2">
              Pagamento Confirmado!
            </h1>
            <p className="text-lg md:text-xl mb-4">
              Obrigado pelo seu pagamento. Seu plano foi atualizado com sucesso.
            </p>
            <Link
              to="/home"
              className="inline-block mt-4 px-6 py-2 rounded-lg bg-green-500 text-gray-100 hover:bg-green-600 transition duration-300 font-semibold"
            >
              Voltar à Página Inicial
            </Link>
          </div>
        </div>
      ) : 
      (
        <div className="z-0">
          <div className="flex-grow px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 mx-auto my-6 z-0">
            <button
              className="group"
              onClick={() => {
                navigate(-1);
              }}
            >
              <div className="flex md:flex lg:hidden">
                <div>
                  <ChevronLeft className="group-hover:font-semibold" />
                </div>
                <div>
                  <span className="text-sm group-hover:font-semibold">
                    Voltar
                  </span>
                </div>
              </div>
            </button>
            {contador === 0 ? (
              <div className="z-0 flex flex-wrap justify-center sm:mt-[40px] sm:justify-between gap-4 max-w-2xl mx-auto px-4">
                <button
                  onClick={() => setContador(1)}
                  className="flex flex-wrap justify-center sm:justify-between gap-4 max-w-2xl mx-auto px-4"
                >
                  <CardTiposDePagamentos {...propsCardPlanoResidencial} />
                </button>

                <button
                  onClick={() => {
                    alert("Tipo de pagamento em Manutençao!");
                  }}
                  className="flex flex-wrap justify-center sm:justify-between gap-4 max-w-2xl mx-auto px-4"
                >
                  <CardTiposDePagamentos {...propsCardPlanoEmpresarial} />
                </button>
              </div>
            ) : (
              <div className="flex flex-col h-full font-questrial z-0">
                <div className="h-14 border flex items-center justify-center bg-gray-100">
                  <h2 className="font-semibold">Detalhes de Pagamento</h2>
                </div>
                <div className="mt-6 w-full max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
                  <div className="flex flex-wrap justify-between gap-6">
                    <div className="flex flex-wrap justify-between gap-6">
                      {/* Descrição do Plano e Dados Bancários */}
                      <div className="w-full md:w-[68%] flex flex-col text-sm text-gray-600 md:mx-auto">
                        <div className="border bg-gray-50 p-4">
                          <h2 className="text-center font-semibold mb-2">
                            Descrição do Plano
                          </h2>
                          <p>
                            <strong>Plano:</strong> {perfil}
                          </p>
                          <p>
                            <strong>Descrição:</strong> {plano.descricao}
                          </p>
                          <p>
                            <strong>Validade/Renovação:</strong>{" "}
                            {plano.validade}
                          </p>
                          <p>
                            <strong>Taxa de Mensalidade:</strong> {plano.preco}{" "}
                            MZN
                          </p>
                          {primeiroPagamento && (
                            <p>
                              <strong>Taxa de Instalacao:</strong>{" "}
                              {TAXA_INSTALACAO} MZN
                            </p>
                          )}
                        </div>
                        <div className="border bg-gray-50 p-4 mt-4">
                          <h2 className="text-center font-semibold mb-2">
                            Dados Bancários para Pagamento
                          </h2>
                          <p>
                            <strong>Banco:</strong> Banco Comercial de
                            Investimento (BCI)
                          </p>
                          <p>
                            <strong>Titular:</strong> EYAZS IMPERIUM
                          </p>
                          <p>
                            <strong>Conta:</strong> 183 034 830 100 01
                          </p>
                          <p>
                            <strong>NIB:</strong> 0008 0000 8303 4830 101 95
                          </p>
                          <p>
                            <strong>IBAN:</strong> MZ59 0008 0000 8303 4830 101
                            95
                          </p>
                          <p>
                            <strong>SWIFT:</strong> CGDIMZM
                          </p>
                        </div>
                      </div>

                      {/* Pagamento e Resumo */}
                      <div className="w-full md:w-[68%] md:mx-auto border bg-gray-50 p-4">
                        <div className="flex justify-center mb-4">
                          <img
                            className="w-32"
                            src="../../images/vodacom.png"
                            alt="Vodacom"
                          />
                        </div>
                        <div className="flex justify-between mb-4">
                          <span>Total</span>
                          <span className="font-semibold">
                            {totalPagamento} MZN
                          </span>
                        </div>
                        <div className="mb-4 rounded-md border border-blue-100 bg-blue-50 p-3 text-slate-800">
                          <label htmlFor="mesesPagamentoResidenciaTrimestre" className="mb-2 block text-sm font-semibold">
                            Meses a pagar
                          </label>
                          <select
                            id="mesesPagamentoResidenciaTrimestre"
                            value={meses}
                            onChange={(e) => setMeses(Number(e.target.value))}
                            className="mb-3 w-full rounded-md border border-blue-200 bg-white px-3 py-2 outline-none focus:border-blue-500"
                          >
                            <option value={3}>3 meses</option>
                            <option value={6}>6 meses</option>
                            <option value={12}>12 meses</option>
                          </select>
                          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                            <div className="rounded-md bg-white px-3 py-2">
                              <p className="text-xs text-slate-500">Validade comprada</p>
                              <p className="font-semibold">{validadeComprada} dias</p>
                            </div>
                            <div className="rounded-md bg-white px-3 py-2">
                              <p className="text-xs text-slate-500">Total a pagar</p>
                              <p className="font-semibold">{totalPagamento} MZN</p>
                            </div>
                          </div>
                        </div>
                        <MpesaStatusCard
                          status={pagamentoStatus}
                          onClose={() => setPagamentoStatus(null)}
                        />
                        <InputPagamento {...propsInputPagamentoMpesa} />
                        {loading ? (
                          <button className="z-0 w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                            <div className="flex justify-center items-center gap-1">
                              <span>Processando</span>
                              <LoaderCircle
                                strokeWidth={4}
                                size={18}
                                className={
                                  loading ? "animate-spin text-white" : ""
                                }
                              />
                            </div>
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              recarregarPacote(); // Certifique-se de que esta função esteja corretamente definida
                            }}
                            className="w-full mt-4 bg-blue-500 p-2 hover:bg-blue-400 text-white rounded-lg"
                          >
                            Pagar
                          </button>
                        )}
                        {mensagemInput && (
                          <div className="flex items-center flex-col text-sm mt-2 p-4 bg-red-500 text-white rounded-lg">
                            <OctagonAlert size={28} />
                            <span>{mensagemInput}</span>
                          </div>
                        )}

                        <p className="text-xs text-gray-400 mt-4">
                          Ao clicar "Pagar", eu confirmo que li e estou de
                          acordo{" "}
                          <Link className="text-blue-500" to="/termosdeuso">
                            com os termos e condições de uso
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* Footer */}
      <div className="bg-blue-500 text-gray-200">
        <Footer />
      </div>
    </div>
  );
}
